import { bookingKeys } from "./query_keys";

export const bookingMutationsKeys = {
  create: () => [...bookingKeys.all(), "create"],
  update: (id: number) => [...bookingKeys.single(id), "update"],
  delete: (id: number) => [...bookingKeys.single(id), "delete"]
};
